import { render } from "./Logo.vue.ts?vue&type=template&id=beb736f4&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=template&id=beb736f4&scoped=true&ts=true"
import script from "./Logo.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue.scss?vue&type=style&index=0&id=beb736f4&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=style&index=0&id=beb736f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb736f4"],['__file',"src/apps/core-app-onboarding/components/Logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beb736f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beb736f4', __exports__)) {
    api.reload('beb736f4', __exports__)
  }
  
  module.hot.accept("./Logo.vue.ts?vue&type=template&id=beb736f4&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=template&id=beb736f4&scoped=true&ts=true", () => {
    api.rerender('beb736f4', render)
  })

}


export default __exports__